const SvgCheck = () => (
  <svg
    width="16px"
    height="10px"
    viewBox="0 0 16 10"
    version="1.1"
    className="absolute top-2 left-1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <title>Icon / Check</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="24" height="24"></rect>
    </defs>
    <g
      id="⚙️-Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icons" transform="translate(-55.000000, -63.000000)">
        <g id="Group" transform="translate(51.000000, 56.000000)">
          <mask id="mask-2" fill="white">
            <use href="#path-1"></use>
          </mask>
          <g id="Mask"></g>
          <path
            d="M5,12 L9.66666667,17 L19,7"
            id="Vector"
            stroke="#f0fdf4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="0,0"
            mask="url(#mask-2)"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const SvgError = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    version="1.1"
    className="absolute top-2 left-1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Icon / Error</title>
    <g
      id="⚙️-Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icons" transform="translate(-55.000000, -63.000000)">
        <g id="Group" transform="translate(51.000000, 56.000000)">
          <rect width="24" height="24" fill="none"></rect>
          <path
            d="M7 7 L17 17"
            id="Line1"
            stroke="#fef2f2"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
          <path
            d="M17 7 L7 17"
            id="Line2"
            stroke="#fef2f2"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const SvgInfo = () => (
  <svg
    width="16px"
    height="16px"
    enableBackground="new 0 0 24 24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="More Info"
    className="ml-1 inline"
  >
    <path
      d="m11 11h1v5m-1.5 0h1.5m1.5 0h-1.5m0 5c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="11.9" cy="8.1" fill="#000" r=".9" />
  </svg>
);

export { SvgCheck, SvgError, SvgInfo };
